/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".table-header[_ngcontent-%COMP%]{justify-content:space-between;align-items:center;margin-bottom:10px}.actions[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center;width:100%}.actions[_ngcontent-%COMP%]   p-dropdown[_ngcontent-%COMP%]{margin-right:10px}@media (max-width:768px){.actions[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start}.actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%], .actions[_ngcontent-%COMP%]   p-dropdown[_ngcontent-%COMP%]{width:50%;margin-right:0;margin-bottom:10px}}"];
export { styles as styles };

